// The headless render worker injects a short-lived service-user access token
// via Playwright addInitScript (never via URL). When present, the app
// authenticates GraphQL with the API's `Token` scheme instead of Firebase.
export const getRenderAuthToken = (): string | null => {
  const token = window.__RENDER_AUTH__?.trim();
  return token === undefined || token === '' ? null : token;
};
